export default {
  title: 'Bestellung Nr. {{number}}',
  labels: {
    item: '{{count}} Artikel',
    item_other: '{{count}} Artikel',
  },
  buttons: {
    details: 'Details',
  },
  fulfillment_statuses: {
    created: 'Erstellt',
    reviewed: 'Überprüft',
    accepted: 'Angenommen',
    preparing: 'In Zubereitung',
    ready: 'Fertig',
    on_delivery: 'In Lieferung',
    picked: 'Abgeholt',
    rejected: 'Abgelehnt',
  },
};
